const ITEMS = [
  "MOVE WITH CARE",
  "BORN IN CAMBODIA",
  "រស់នៅសកម្មជាមួយគ្នា",
  "EVERYDAY SUPPORT",
  "STAY ACTIVE",
  "MADE TO MOVE",
];

const Row = ({ hidden }) => (
  <div className="marquee-row" aria-hidden={hidden || undefined}>
    {ITEMS.map((item, i) => (
      <span className="marquee-item" key={i}>
        {item}
        <img src="/flower-white.png" alt="" className="marquee-flower" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="marquee" data-testid="marquee-strip">
      <div className="marquee-track">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
